import {ResizeObserver} from '@juggle/resize-observer';
import React, { useEffect, Suspense, useState } from 'react';
import './CanvasContainer.scss';
import { Canvas, useLoader, useThree } from 'react-three-fiber';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import Loader from './Loader';
import { DefaultLoadingManager } from 'three'

const Model = (props) => {
  const object = useLoader(GLTFLoader, process.env.PUBLIC_URL + '/Assets/Models/' + props.name + '.glb')

  object.castShadow = true;
  object.receiveShadow = false;
  object.scene.scale.set(5,5,5);

  const boardPos = [
    ["9579200001", -.215],
    ["9579206100",-.068],
    ["9579206101",-.068],
    ["9579206102",-.068],
    ["9579207100",-.071],
    ["9579207101",-.071],
    ["9579208100",-.062],
    ["9579208101",-.062],
    ["9579208102",-.062],
    ["9579208103",-.062],
    ["9579209100",-.062],
    ["9579209101",-.062],
    ["9579209102",-.062],
    ["9579210100",-.062],
    ["9579210101",-.062],
    ["9579210102",-.062],
    ["9579210103",-.062],
    ["9579212100",-.071],
    ["9579213100",-.069],
    ["9579216101",-.063],
    ["9579216100",-.062],
    ["9579227100",-.071]
  ]

  //Set Z position based on the board
  if (props.name !== "Flex_Case") {
    if (props.name === "9579200001") {
      object.scene.position.z = -.215
    } else {
      for (let i = 0; i < boardPos.length; i++) {
        if (props.name === boardPos[i][0]) {
          object.scene.position.z = boardPos[i][1]
        }
      }
    } 
  } else {
    object.scene.position.set(0, 0, 0)
  }

  //Set y position based on the slot being inserted into
  if (props.index === 1) {
    object.scene.position.y = .16;
  } else if (props.index === 2) {
    object.scene.position.y = .092;
  } else if (props.index === 3) {
    object.scene.position.y = .042;
  } else if (props.index === 4) {
    object.scene.position.y = -.008;
  } else if (props.index === 5) {
    object.scene.position.y = -.058;
  } else if (props.index === 6) {
    object.scene.position.y = -.108;
  } else if (props.index === 7) {
    object.scene.position.y = -.158;
  }

  //Adjust y position of boards that have nonstandard sizing
  if (props.name === "9579207101") {
    object.scene.position.y = object.scene.position.y - .005;
  } else if (props.name === "9579206101" || props.name === "9579206102" || props.name === "9579206100") {
    object.scene.position.y = object.scene.position.y + .002;
  } else if (props.name === "9579207100") {
    object.scene.position.y = object.scene.position.y - .003;
  } 
  
  return <primitive object={object.scene.clone()} dispose={null} {...props}/>;
}
  
const CameraController = (props) => {
  const { camera, gl } = useThree();
  camera.castShadow = true;
  camera.position.set(0, 0, .7);
  camera.rotation.set(0, 0, 0);
  useEffect(
    () => {
      const controls = new OrbitControls(camera, gl.domElement);

      controls.enableRotate = true
      controls.enableZoom = true
      controls.enablePan = false
      controls.minDistance = .65;
      controls.maxDistance = .8;
      return () => {
        controls.dispose();
      };
    },
    [camera, gl]
  );

  return null;
};

const ModelList = (props) => {
  let arr = []
  for (let i = 0; i < props.models.length; i++) {
    if(props.models[i] !== "") {
      arr.push(<Model name={props.models[i]} index={i + 1} key={i + 1}/>)
    } else {
      if (i + 1 !== 1) {
        arr.push(<Model name={"9579200001"} index={i + 1} key={i + 1}/>)
      }
    }
  }
  return arr
}

function CanvasContainer(props) {
  const [loader, setLoader] = useState(0)
  //set render toggle back to false after the model has been rendered once
  useEffect(() => {
    if(props.rerender === true) {
      props.rendered()
    }
  })

  //Activate the loader until the model is fully loaded
  DefaultLoadingManager.onStart = function ( url, itemsLoaded, itemsTotal ) {
    setLoader(1) 
  };
  
  //Deactivate the loader when model is fully loaded
  DefaultLoadingManager.onLoad = function ( ) {  
    setLoader(0)
  };

  return (
    <div className={'CanvasContainer ' + props.windowSize + ' ' + props.visible}>
      <Canvas pixelRatio={window.devicePixelRatio} resize={{polyfill: ResizeObserver}} style={{height: '100%', width: '100%'}}>
          <ambientLight intensity={.7} />
          <pointLight position={[-3, 4, 10]} intensity={0.5} />
          <pointLight position={[0, 2, -10]} intensity={0.5} />
          <Suspense fallback={null}> 
            <Model name={'Flex_Case'} index={0}/>
            <ModelList models={props.models}/>   
          </Suspense>
          <CameraController position={[0, 0, .7]} {...props}/>
      </Canvas>
      <Loader active={loader} size={props.windowSize}/>
    </div>
  );
}

export default React.memo(CanvasContainer, (prevProps, nextProps) => {
  if(prevProps.windowSize === "Web") {
    return nextProps.rerender === false
  } else {
    return prevProps.visible === nextProps.visible
  }
});